module.exports = __webpack_public_path__ + "static/media/tools-fill-in-the-blank.e819dcc0.svg";